__turbopack_context__.v({
  "iconContainer": "AuthProfileTypeIcon-module-scss-module__pqE16G__iconContainer",
});
